










































































































































import addressWithLookup from '@/components/address-with-lookup.vue';
import { ClientAccount } from '@/shared/clients/client-account';
import { ClientAccountWillExecutor } from '@/shared/clients/client-account-will-executor';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');

@Component({
    components: {
        addressWithLookup,
    },
})
export default class WillExecutorDetail extends Vue {
    @partnerPracticesModule.Getter('partnerPracticeName') private partnerPracticeName!: (partnerPracticeId: string | null) => string;

    @Prop({ required: true }) public client!: ClientAccount;
    @Prop({ required: true }) public executor!: ClientAccountWillExecutor;
    @Prop({ required: true }) public executorTypeRequired!: boolean;
    @Prop({ required: true }) public addressStep!: number;

    private showIsRlgExecutor: boolean = false;

    @Watch('executor.isProfessionalExecutor', { immediate: true })
    private onIsProfessionalExecutorChanged(value: boolean | null): void {
        this.showIsRlgExecutor = value === true;
    }
}
